/* ALSAEY | Product-specific quantity quick picker; no cart mutations */
(function () {
  'use strict';
  let current = null;
  const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  function inputFrom(target) {
    return target instanceof Element ? target.closest('.sae-quantity .quantity__input') : null;
  }

  function close() {
    if (!current) return;
    current.input.setAttribute('aria-expanded', 'false');
    current.panel.remove();
    current = null;
  }

  function stockMax(input) {
    if (!input.max) return Infinity;
    const parsed = Number(input.max);
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : Infinity;
  }

  function quantity(input) {
    const value = Number(input.value);
    return Number.isFinite(value) ? Math.max(1, Math.floor(value)) : 1;
  }

  function syncSummary(input) {
    const sectionId = input.id.replace(/^Quantity-/, '');
    const summary = document.getElementById('sae-quantity-pricing-' + sectionId);
    if (!summary) return;
    const count = quantity(input);
    const countLabel = summary.querySelector('[data-sae-selected-quantity]');
    if (countLabel) countLabel.textContent = String(count);
    const tiers = summary.querySelectorAll('[data-sae-tier-min]');
    let qualifying = null;
    tiers.forEach(function (tier) {
      tier.classList.remove('sae-tier-active');
      const min = Number(tier.getAttribute('data-sae-tier-min'));
      if (Number.isFinite(min) && count >= min &&
          (!qualifying || min > Number(qualifying.getAttribute('data-sae-tier-min')))) {
        qualifying = tier;
      }
    });
    if (qualifying) qualifying.classList.add('sae-tier-active');
  }

  function assign(input, value) {
    const max = stockMax(input);
    if (max < 1 || input.disabled) return;
    const parsed = Number(value);
    const newValue = Math.min(max, Math.max(1, Math.floor(Number.isFinite(parsed) ? parsed : 1)));
    input.value = String(newValue);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncSummary(input);
  }

  function open(input) {
    if (input.disabled) return;
    if (current && current.input === input) return;
    close();
    const host = input.closest('.sae-quantity');
    if (!host) return;
    const max = stockMax(input);
    if (max < 1) return;
    const panel = document.createElement('div');
    panel.className = 'sae-qty-menu';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', isArabic ? 'اختيار الكمية' : 'Select quantity');
    const shownMax = Math.min(5, max);
    for (let n = 1; n <= shownMax; n++) {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', String(quantity(input) === n));
      button.textContent = String(n);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        assign(input, n);
        close();
      });
      panel.appendChild(button);
    }
    if (max > 5) {
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'sae-qty-more';
      more.textContent = isArabic ? 'أدخل كمية أكبر…' : 'Enter a larger quantity…';
      more.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        close();
        input.focus();
        input.select();
      });
      panel.appendChild(more);
    }
    host.appendChild(panel);
    current = {input: input, panel: panel};
    input.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse') return;
    const input = inputFrom(event.target);
    if (input) open(input);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse' || !current) return;
    const host = current.input.closest('.sae-quantity');
    if (host && host.contains(event.target) && event.relatedTarget &&
        !host.contains(event.relatedTarget)) close();
  });

  document.addEventListener('focusin', function (event) {
    const input = inputFrom(event.target);
    if (input) open(input);
    else if (current && !current.panel.contains(event.target)) close();
  });

  document.addEventListener('click', function (event) {
    const input = inputFrom(event.target);
    if (input) { open(input); return; }
    if (current && !current.panel.contains(event.target)) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (current) { close(); event.preventDefault(); }
      return;
    }
    const input = inputFrom(event.target);
    if (input && event.key === 'ArrowDown') {
      open(input);
      if (current) {
        const first = current.panel.querySelector('button');
        if (first) first.focus();
        event.preventDefault();
      }
    }
  });

  document.addEventListener('change', function (event) {
    const input = inputFrom(event.target);
    if (!input) return;
    // Theme's native QuantityInput also normalizes and honors input.max.
    assignNoDispatch(input);
    syncSummary(input);
  });

  function assignNoDispatch(input) {
    const max = stockMax(input);
    if (max < 1) return;
    const val = Number(input.value);
    input.value = String(Math.min(max, Math.max(1, Math.floor(Number.isFinite(val) ? val : 1))));
  }

  document.addEventListener('input', function (event) {
    const input = inputFrom(event.target);
    if (input && input.value) syncSummary(input);
  });

  // Reject out-of-stock and excess values before the theme handles add-to-cart.
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
    const input = document.querySelector('.sae-quantity .quantity__input[form="' + form.id + '"]');
    if (input && stockMax(input) < 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (input) { assignNoDispatch(input); syncSummary(input); }
  }, true);
})();